import { render, staticRenderFns } from "./ImportFromBundle.vue?vue&type=template&id=572823e1&scoped=true&"
import script from "./ImportFromBundle.vue?vue&type=script&lang=js&"
export * from "./ImportFromBundle.vue?vue&type=script&lang=js&"
import style0 from "./ImportFromBundle.vue?vue&type=style&index=0&id=572823e1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "572823e1",
  null
  
)

export default component.exports